(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hk-help-center"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hk-help-center')) {
    customElements.define('hk-help-center', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.classList.add('is-enhanced');
        this.search = this.querySelector('[data-help-search]');
        this.items = [...this.querySelectorAll('[data-help-item]')];
        this.groups = [...this.querySelectorAll('[data-help-group]')];
        this.categories = [...this.querySelectorAll('[data-help-category]')];
        this.resultTitle = this.querySelector('[data-help-title]');
        this.status = this.querySelector('[data-help-status]');
        this.all = this.querySelector('[data-help-all]');
        this.clear = this.querySelector('[data-clear-search]');
        this.mode = 'popular';
        this.index = new Map(this.items.map(item => [item, this.normalize(item.textContent + ' ' + item.dataset.keywords)]));
        this.search.addEventListener('input', () => this.update());
        this.clear.addEventListener('click', () => { this.search.value = ''; this.update(); this.search.focus(); });
        this.all.hidden = false;
        this.all.addEventListener('click', () => { this.mode = 'all'; this.search.value = ''; this.update(); history.replaceState(null, '', location.pathname + location.search); this.focusAnswers(); });
        this.categories.forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.mode = link.dataset.helpCategory;
          this.search.value = '';
          this.update();
          history.replaceState(null, '', link.getAttribute('href'));
          this.focusAnswers();
        }));
        this.querySelectorAll('[data-help-question]').forEach(link => link.addEventListener('click', event => {
          event.preventDefault();
          this.openQuestion(link.dataset.helpQuestion);
        }));
        this.items.forEach(item => item.addEventListener('toggle', () => {
          if (item.open) this.items.forEach(other => { if (other !== item) other.open = false; });
        }));
        this.update();
        const hash = location.hash.slice(1);
        if (hash.startsWith('help-category-')) {
          const category = hash.replace('help-category-', '');
          if (this.categories.some(link => link.dataset.helpCategory === category)) { this.mode = category; this.update(); }
        } else if (hash.startsWith('help-')) { this.openQuestion(hash.slice(5), false); }
      }
      normalize(value) { return value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ').trim(); }
      update() {
        const query = this.normalize(this.search.value.trim());
        const synonyms = [['paket','leverans','frakt','sparning','sparar','spara','tracking','parcel','shipping','delivery','package'],['retur','returnera','angerratt','oppet kop','return','returns','withdrawal'],['order','orders','bestallning','bestallningar'],['reklamation','reklamera','reklamerar','trasig','skadad','felaktig','faulty','damaged','claim','claims'],['forhandsbestallning','forhandsbokning','forboka','preorder','preorders'],['poang','bonus','medlemskap','points','rewards','membership']];
        const words = query.split(/\s+/).filter(Boolean);
        const stopWords = new Set(['hur','vad','nar','var','ar','kan','jag','min','mitt','mina','en','ett','det','den','de','ni','era','med','pa','i','om','att','ska','som','for','och','gor','what','how','when','where','is','are','can','i','my','a','an','the','do','does','to','of']);
        const meaningful = words.filter(word => !stopWords.has(word));
        const tokens = meaningful.length ? meaningful : words;
        this.dataset.view = query ? 'search' : this.mode;
        let count = 0;
        this.items.forEach(item => {
          const text = this.index.get(item);
          const match = query ? tokens.every(token => {
            const group = synonyms.find(words => words.includes(token));
            return text.includes(token) || Boolean(group && group.some(word => text.includes(word)));
          }) : this.mode === 'all' || (this.mode === 'popular' ? item.dataset.popular === 'true' : item.dataset.category === this.mode);
          item.hidden = !match;
          if (!match) item.open = false;
          if (match) count++;
        });
        this.groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-help-item]')].some(item => !item.hidden); });
        this.categories.forEach(link => {
          if (!query && link.dataset.helpCategory === this.mode) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        const category = this.categories.find(link => link.dataset.helpCategory === this.mode);
        this.resultTitle.textContent = query ? this.dataset.results : this.mode === 'popular' ? this.dataset.popular : category ? category.querySelector('strong').textContent : this.dataset.all;
        this.status.textContent = query ? (count === 1 ? this.status.dataset.countOne : this.status.dataset.count.replace('[count]', String(count))) : '';
        this.clear.hidden = !query;
        this.all.hidden = this.mode === 'all' && !query;
        this.querySelector('[data-help-empty]').hidden = count > 0;
      }
      focusAnswers() {
        this.resultTitle.focus({preventScroll:true});
        this.resultTitle.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
      }
      openQuestion(id, scroll = true) {
        const item = this.items.find(entry => entry.id === 'help-' + id);
        if (!item) return;
        this.search.value = '';
        this.mode = item.dataset.category;
        this.update();
        this.items.forEach(other => { other.open = other === item; });
        history.replaceState(null, '', '#' + item.id);
        if (scroll) { item.querySelector('summary').focus({preventScroll:true}); item.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'}); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hk-valuation"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.hkvReady) return;
    root.dataset.hkvReady = 'true';
    const select = root.querySelector('[data-hkv-select]');
    const update = () => {
      const service = select?.selectedOptions[0]?.dataset.service;
      if (!service) return;
      root.querySelectorAll('[data-hkv-info]').forEach(panel => { panel.hidden = panel.dataset.hkvInfo !== service; });
    };
    select?.addEventListener('change', update);
    root.querySelectorAll('[data-hkv-service]').forEach(link => {
      link.addEventListener('click', () => {
        if (!select) return;
        const option = Array.from(select.options).find(item => item.dataset.service === link.dataset.hkvService);
        if (option) select.value = option.value;
        update();
      });
    });
    update();
    const status = root.querySelector('[data-hkv-success], [data-hkv-error]');
    if (status) { status.focus({preventScroll: true}); status.scrollIntoView({block: 'center'}); }
  }
  document.querySelectorAll('.hkv').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.hkv').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
